import { Duration } from "luxon";

/** How long the pointer rests on a roster cell before the cell's tooltip opens. */
export const TOOLTIP_ENTER_DELAY = Duration.fromObject({ milliseconds: 1500 });
